import React, { useState } from "react";
import "./windowing.css";
import SplitPane, { Pane } from "split-pane-react";
import "split-pane-react/esm/themes/default.css";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const App = () => {
  const [windowStates, setWindowStates] = useState([true, true, true, true]);
  const initialUrls = [
    { url: "/dashboard/monitoring", name: "Monitoring" },
    { url: "/dashboard/ticketing/board", name: "Ticketing" },
    { url: "/dashboard/reports-history", name: "Report History" },
    { url: "/dashboard/alerts-and-notifications", name: "Alarms and Notifications" },
    { url: "/dashboard/account-management", name: "Account Management" },
    { url: "/dashboard/tasks", name: "Tasks" },
    { url: "/dashboard/notebook", name: "Notebook" },
    { url: "/dashboard/explore-complexes", name: "Explore Complexes" },
    { url: "/dashboard", name: "Home" }
  ];
  const [selectedIframes, setSelectedIframes] = useState(initialUrls.map(({ url }) => ({ url, history: [url] })));

  const handleBackClick = (index) => {
    const iframeHistory = selectedIframes[index].history;
    if (iframeHistory.length > 1) {
      iframeHistory.pop(); // Remove the current URL
      const previousUrl = iframeHistory[iframeHistory.length - 1]; // Get the previous URL
      setSelectedIframes(prevState => {
        const newState = [...prevState];
        newState[index].history = iframeHistory;
        return newState;
      });
      navigateIframe(index, previousUrl);
      // Update the selected option in the <select> element
      setSelectedOption(index, previousUrl);
    }
  };
  
  const setSelectedOption = (index, url) => {
    setSelectedIframes(prevState => {
      const newState = [...prevState];
      newState[index].url = url;
      return newState;
    });
  };

  const handleIframeChange = (index, event) => {
    const newUrl = event.target.value;
    setSelectedIframes(prevState => {
      const newState = [...prevState];
      newState[index].url = newUrl;
      newState[index].history.push(newUrl); // Push the new URL to history
      return newState;
    });
    navigateIframe(index, newUrl);
  };

  const navigateIframe = (index, url) => {
    const iframe = document.getElementById(`iframe-${index}`);
    if (iframe) {
      iframe.src = url;
    }
  };

  const renderWindow = (index) => {
    if (windowStates[index]) {
      return (
        <div className={`window window-${index}`} key={`window-${index}`}>
          
          <div className="heading">
            <button onClick={() => handleBackClick(index)} className="backDiv"><ArrowBackIcon/></button>
            <select
              value={selectedIframes[index].url}
              onChange={(event) => handleIframeChange(index, event)}
            >
              {initialUrls.map(({ url, name }, idx) => (
                <option key={idx} value={url}>{name}</option>
              ))}
            </select>
            
          </div>
          <div className="content">
            <iframe
              id={`iframe-${index}`}
              className="iframeWindowing"
              src={selectedIframes[index].url}
              title={`Window ${index + 1}`}
            />
          </div>
        </div>
      );
    }
    return null;
  };

  const [pageSizes, setPageSizes] = useState([100, 100, "auto"]);
  const [upSizes, setUpSizes] = useState([100, 100, "auto"]);
  const [downSizes, setDownSizes] = useState([100, 100, "auto"]);

  return (
    <div style={{ height: "100%" }}>
      <SplitPane split="horizontal" sizes={pageSizes} onChange={setPageSizes}>
        <Pane>
          <SplitPane split="vertical" sizes={upSizes} onChange={setUpSizes}>
            <Pane>{renderWindow(0)}</Pane>
            <Pane>{renderWindow(3)}</Pane>
          </SplitPane>
        </Pane>
        <Pane>
          <SplitPane split="vertical" sizes={downSizes} onChange={setDownSizes}>
            <Pane>{renderWindow(1)}</Pane>
            <Pane>{renderWindow(2)}</Pane>
          </SplitPane>
        </Pane>
      </SplitPane>
      <div className="help-drag"></div>
    </div>
  );
};

export default App;
